<template>
<div class="navbar-item has-dropdown has-dropdown-up is-hoverable dropdown" v-if="user">
  <a class="navbar-link is-arrowless navbar-username dropdown-trigger" >
    <user-image class="menu-item-icon" size="is-24x24" />
    <label aria-haspopup="true" aria-controls="dropdown-menu3" class="user-name">{{ user.firstName }} {{user.lastName}}</label>
  </a>
  <div  class="navbar-dropdown dropdown-menu" id="dropdown-menu3" role="menu">
    <router-link class="navbar-item" to="/me">
      <label>{{$t('nav.profile')}}</label>
    </router-link>
    <router-link class="navbar-item" to="/settings">
      <label>{{$t('nav.settings')}}</label>
    </router-link>
    <a class="navbar-item"  href="https://www.hirevibes.io/" target="_blank">
      <label>{{$t('nav.about')}}</label>
    </a>
    <a class="navbar-item" @click.prevent="onLogout"><label>{{$t('nav.logout')}}</label></a>
<!--    <user-items />-->
    <router-link v-if="isAdmin || isJobBoardOwner || isHirer" class="navbar-item" to="/admin/companies">
      <label>My Company</label>
    </router-link>
    <router-link v-if="isAdmin || isJobBoardOwner" class="navbar-item" to="/admin/hirers">
      <label>{{$t('nav.hirers')}}</label>
    </router-link>
  </div>
</div>
</template>
<script>
import UserImage from '@/components/general/user-image'
import UserItems from '@/components/navbar/flag-items'
import { mapState, mapActions } from 'vuex'
import {userSession} from '@/helpers/stack-auth'

export default {
  components: {
    UserImage,
    UserItems
  },
  computed: {
    ...mapState('users', ['user']),
    ...mapState('wallet', ['isStackConnected']),
    isAdmin () {
      if (this.user) {
        if (this.user.profile === 'admin' || this.user.profile === 'superadmin') {
          return true
        }
      }
      return false
    },
    isJobBoardOwner () {
      return this.user && this.user.profile === 'jobboardowner'
    },
    isHirer () {
      return this.user && this.user.profile === 'hirer'
    }
  },
  props: {
    isDropdown: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('app', ['logout']),
    ...mapActions('wallet', ['disconnectStack']),
    async onLogout () {
      await this.logout()
      if (this.isStackConnected) {
        userSession.signUserOut()
        this.disconnectStack()
      }
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss" scoped>
  .navbar-link {
    padding: 0;
  }
  .navbar-dropdown {
    .navbar-link {
      label {
        margin-left: 0;
        font-size: 1rem;
      }
    }
    .navbar-item {
      label {
        margin-left: 0;
        font-size: 1rem;
      }
    }
  }

  .menu-close {
    .navbar-link {
      label.user-name {
        display: none
      }
    }
  }

  .navbar-username {
    overflow: hidden;

    label {
      &.user-name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .navbar-dropdown {
    border-bottom-width: 0px !important;
    border-radius: 8px !important;
    box-shadow: 0 8px 8px rgba(17, 17, 17, 0.1) !important;
    border: 1px solid #ddd !important;
  }
  @media screen and (max-width: 769px) {
    .has-dropdown {
      .navbar-link {
        display: flex;
      }
    }
    #dropdown-menu3{
      padding-bottom: 30px;
    }
    .navbar-dropdown {
      width: 100%;
      margin: 0;
      border: 0px solid !important;
      text-align: left;
      border-left: 1px solid #ddd !important;
      margin-left: 12px;
      margin-top: 8px;
      padding-top: 0px;
      padding-bottom: 0px;
      border-radius: 0 !important;
      padding-left: 24px;

      .navbar-lan-switcher, .navbar-item {
        justify-content: flex-start;
      }
      .navbar-item {
        padding-left: 4px;
      }
    }
  }
  @media screen and (min-width: 769px) {
    .navbar-dropdown {
      .navbar-item {
        padding-right: 0rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/user-items.vue